import { useEffect, useState } from 'react';
import { NhaCungCap, TaiKhoan } from '@/types/schemas';
import { QUERY_KEYS } from '@/constants';
import { useCRUD } from '@/hooks';

export interface UseSearchFieldStatesReturn {
  account: TaiKhoan | null;
  setAccount: (account: TaiKhoan | null) => void;
  supplier: NhaCungCap | null;
  setSupplier: (supplier: NhaCungCap | null) => void;
}

export function useSearchFieldStates(): UseSearchFieldStatesReturn {
  const { data: defaultAccounts } = useCRUD<TaiKhoan>({
    endpoint: `${QUERY_KEYS.TAI_KHOAN}/filter_by_code`,
    searchData: { tk: '3311' }
  });
  const [account, setAccount] = useState<TaiKhoan | null>(defaultAccounts[0]);
  const [supplier, setSupplier] = useState<NhaCungCap | null>(null);

  useEffect(() => {
    if (!account && defaultAccounts.length > 0) {
      setAccount(defaultAccounts[0]);
    }
  }, [account, defaultAccounts]);

  return {
    account,
    setAccount,
    supplier,
    setSupplier
  };
}
